import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux/es/redux";
import { getPermissionsAction } from "../../actions/common.action";
import { getDashboardNotifications } from "../../actions/dashboard.action";
import { get, debounce } from "lodash";
import { getLocalstorage, isValidArray } from "../../helper";
import { withRouter } from "react-router-dom";
import { PERMISSIONS_BY_MODULE } from "../../helper";
import { PATHS, STATUS } from "../../constant";
import { clearProjectDataAction } from "../../actions/formData.action";
import { clearDebounce } from "../../helper";

export default WrappedComponent => {
  class Permissions extends Component {
    state = {
      isLoggedIn: !!getLocalstorage("token"),
      permissionList: {}
    };

    componentDidMount = async () => {
      const {
        history: {
          location: { pathname }
        },
        isPermissionsLoading,
        clearProjectDataDispatch,
        getDashboardNotificationsDispatch
      } = this.props;
      const paths = [
        PATHS.CREATE_PROJECT,
        PATHS.PREVIEW,
        PATHS.PROJECT_DETAILS,
        PATHS.ISSUE_DETAIL
      ];
      paths.indexOf(pathname) === -1 && clearProjectDataDispatch();
      //getDashboardNotificationsDispatch(undefined);
      isPermissionsLoading !== STATUS.LOADING && this.setPermissions();
    };

    componentWillReceiveProps(nextProps, nextContext) {
      const { permissionsListing, isPermissionsLoading } = nextProps;
      if (
        getLocalstorage("token") &&
        !isValidArray(Object.keys(permissionsListing))
      ) {
        isPermissionsLoading !== STATUS.LOADING && this.setPermissions();
      }
    }

    setPermissions = () => {
      const { getPermissionsDispatch } = this.props;
      const isLoggedIn = !!getLocalstorage("token");
      isLoggedIn && getPermissionsDispatch();
    };

    render() {
      const { isLoggedIn } = this.state;
      const { permissionsListing } = this.props;
      const permissionList = PERMISSIONS_BY_MODULE(
        get(permissionsListing, "data")
      );

      return (
        (isLoggedIn &&
          get(permissionsListing, "status") &&
          isValidArray(Object.keys(permissionList)) && (
            <WrappedComponent permission={permissionList} {...this.props} />
          )) ||
        null
      );
    }
  }

  function mapStateToProps(state) {
    return {
      permissionsListing: state.commonReducer.permissionsListing,
      isPermissionsLoading: state.commonReducer.isPermissionsLoading
    };
  }

  function mapDispatchToProps(dispatch) {
    return bindActionCreators(
      {
        clearProjectDataDispatch: clearProjectDataAction,
        getPermissionsDispatch: getPermissionsAction,
        getDashboardNotificationsDispatch: getDashboardNotifications
      },
      dispatch
    );
  }

  return withRouter(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(Permissions)
  );
};
